import { computed, Ref, unref } from 'vue';
import { skipToken, useQuery } from '@tanstack/vue-query';
import { fetchSingleScanFolders } from './report.endpoints';
import { foldersQueryKeys } from './folders.queryKeys';
import { TSingleScanFoldersPayload } from '../models/types';

export function useFetchSingleScanFolders(payloadRef: Ref<TSingleScanFoldersPayload | null>) {
  const query = useQuery({
    queryKey: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) return foldersQueryKeys.all;
      return foldersQueryKeys.singleScan(payload.jobId, {
        complianceRequirementId: payload.complianceRequirementId,
        complianceRequirementItemId: payload.complianceRequirementItemId,
      });
    }),
    queryFn: computed(() => {
      const payload = unref(payloadRef);
      if (!payload) {
        return skipToken;
      }

      return () => fetchSingleScanFolders(payload);
    }),
  });

  return query;
}
